import React from 'react';
import StackLoader from '@bd/bdcore-navigation-stacks';
import { ConfigStore } from '@bd/bdcore-utilities';
import 'bootstrap/dist/css/bootstrap.min.css';
import configuration from './configuration';
import './styles';
import StyleGuide from './pages/StyleGuide';
import Communities from './pages/Communities';
import CommunityDetail from './pages/CommunityDetail';
import CommunityDetailHomes from './pages/CommunityDetail/Homes';
import CommunityDetailPlans from './pages/CommunityDetail/FloorPlans';
import Homes from './pages/Homes';
import HomeDetail from './pages/HomeDetail';
import Plans from './pages/Plans';
import PlanDetail from './pages/PlanDetail';
import ModelHomes from './pages/ModelHomes';
import OpenHouses from './pages/OpenHouses';
import WarrantyRequestThankYou from './pages/WarrantyRequest/ThankYou';
import SpecialOffers from './pages/SpecialOffers';
import SpecialOffersDetail from './pages/SpecialOffersDetail';
import MyAccount from './pages/MyAccount';
import Compare from './pages/Compare';
import MyAccountPasswordReset from './pages/MyAccount/PasswordReset';
import PageLoader from './components/PageLoader';

ConfigStore.setConfig(configuration);

function Entry() {
  return (
    <StackLoader
      stack="RegionalMetros"
      components={[
        { override: 'NoRoute', component: PageLoader('error_404') },
        { override: 'Index', component: PageLoader('home_page') },
        { override: 'CommunityDetail', component: CommunityDetail },
        { override: 'CommunityDetailHomes', component: CommunityDetailHomes },
        { override: 'CommunityDetailPlans', component: CommunityDetailPlans },
        { override: 'CommunitiesList', component: Communities },
        { override: 'HomesList', component: Homes, filtersRemove: ['OpenHouse', 'Model'] },
        { override: 'HomeDetail', component: HomeDetail },
        { override: 'PlansList', component: Plans },
        { override: 'PlanDetail', component: PlanDetail },
        { override: 'BlogpostList', component: PageLoader('blog') },
        { override: 'BlogpostDetail', component: PageLoader('blog_detail') },
      ]}
      routes={[
        { name: 'style-guide', exact: true, path: '/style-guide', component: StyleGuide },
        { name: 'model-homes', exact: true, path: '/model-homes', component: ModelHomes, filtersRemove: ['OpenHouse'], filters: { Model: [{ value: true }] } },
        { name: 'open-houses', exact: true, path: '/open-houses', component: OpenHouses, filtersRemove: ['Model'], filters: { OpenHouse: [{ value: true }] } },
        { name: 'build-on-your-lot', exact: true, path: '/build-on-your-lot', component: PageLoader('build_on_your_lot') },
        { name: 'special-offers', exact: true, path: '/special-offers', component: SpecialOffers },
        { name: 'special-offers-detail', exact: true, path: '/special-offers/:title', component: SpecialOffersDetail },
        { name: 'video-gallery', exact: true, path: '/video-gallery', component: PageLoader('video_gallery') },
        { name: 'video-gallery-filtered', exact: true, path: '/video-gallery/:gallery', component: PageLoader('video_gallery'), sitemapIgnore: true },
        { name: 'photo-gallery', exact: true, path: '/photo-gallery', component: PageLoader('photo_gallery') },
        { name: 'photo-gallery', exact: true, path: '/photo-gallery/:photo_gallery', component: PageLoader('photo_gallery'), sitemapIgnore: true },
        { name: 'virtual-tours', exact: true, path: '/virtual-tours', component: PageLoader('virtual_tours') },
        { name: 'interactive-home', exact: true, path: '/interactive-home', component: PageLoader('interactive_home') },
        { name: 'our-process', exact: true, path: '/our-process', component: PageLoader('our_process') },
        { name: 'design-center', exact: true, path: '/design-center', component: PageLoader('design_center') },
        { name: 'energy-efficiency', exact: true, path: '/energy-efficiency', component: PageLoader('energy_efficiency') },
        { name: 'financing-info', exact: true, path: '/financing-info', component: PageLoader('financing_info') },
        { name: 'warranty-info', exact: true, path: '/warranty-info', component: PageLoader('warranty_info') },
        { name: 'military-homebuyers', exact: true, path: '/military-homebuyers', component: PageLoader('military_homebuyers') },
        { name: 'frequently-asked-questions', exact: true, path: '/faq', component: PageLoader('frequently_asked_questions') },
        { name: 'about-us', exact: true, path: '/about-us', component: PageLoader('about_us') },
        { name: 'meet-the-team', exact: true, path: '/meet-the-team', component: PageLoader('meet_the_team') },
        { name: 'testimonials', exact: true, path: '/testimonials', component: PageLoader('testimonials') },
        { name: 'awards-and-affiliations', exact: true, path: '/awards-and-affiliations', component: PageLoader('awards_affiliations') },
        { name: 'contact-us', exact: true, path: '/contact-us', component: PageLoader('contact_us') },
        { name: 'warranty-request', exact: true, path: '/warranty-request', component: PageLoader('warranty_request') },
        { name: 'refer-a-friend', exact: true, path: '/refer-a-friend', component: PageLoader('refer_a_friend') },
        { name: 'realtors', exact: true, path: '/realtors', component: PageLoader('realtors') },
        { name: 'vendor-request', exact: true, path: '/vendor-request', component: PageLoader('vendor_request') },
        { name: 'careers', exact: true, path: '/careers', component: PageLoader('careers') },
        { name: 'warranty-request-thank-you', exact: true, path: '/warranty-request/thank-you', component: WarrantyRequestThankYou, sitemapIgnore: true },
        { name: 'privacy-policy', exact: true, path: '/privacy-policy', component: PageLoader('privacy_policy') },
        { name: 'terms', exact: true, path: '/terms', component: PageLoader('terms') },
        { name: 'accessibility', exact: true, path: '/accessibility', component: PageLoader('accessibility') },
        { name: 'my-account-password-reset', exact: true, path: '/my-account/password-reset', component: MyAccountPasswordReset, sitemapIgnore: true },
        { name: 'my-account', exact: true, path: '/my-account', component: MyAccount, sitemapIgnore: true },
        { name: 'my-account', exact: true, path: '/my-account/:product', component: MyAccount, sitemapIgnore: true },
        { name: 'compare', exact: true, path: '/compare', component: Compare, sitemapIgnore: true },
      ]}
    />
  );
}

export default Entry;



// WEBPACK FOOTER //
// ./src/Entry.js